import Tooltip from '../../../ui/Tooltip';
import IconInfo from '../../icon/IconInfo';
import React from 'react';

export default function ReviewTooltip() {
  return (
    <Tooltip
      content={(
        <div className="w-64">Workshop Butler adds a consent checkbox after this question so your attendees can explicitly
                              give you a
                              permission to convert their feedback to testimonial<br/><br/>
                              This question has a different wording (<em>What were specific qualities of the
                                                                      facilitator(s)?</em>)
                              for events of Collaboration Superpowers, European Scrum, Lean Change Management,
                              Management 3.0, ShiftUp, Personal Agility Institute and Scrum Ambassadors
                              brands.
        </div>)}
      label="reviewTip" className="pl-0.5">
      <IconInfo className="text-gray-dark "/>
    </Tooltip>
  );
}
